<template>
  <header class="header-container">
    <section class="container">
      <img
        class="icon toplupe"
        v-lazy="
          require(`@/assets/images/detail/mobile-legends/desktop/new-hander-logo.png`)
        "
        alt="icon"
      />
      <span class="x">X</span>
      <img
        class="icon"
        v-lazy="require(`@/assets/images/detail/pubgm/logo.png`)"
        alt="icon"
      />
      <span class="login-btn" v-if="showLoginBtn">
        <UserCenter
          :page="gameName"
          ref="loginComp"
          @login="getLoginResult"
          type="horizontalScreen"
          position="center"
        />
      </span>
    </section>
  </header>
</template>

<script>
  import { mapState } from 'vuex'
  import UserCenter from '@/components/UserCenter'

  export default {
    components: {
      UserCenter,
    },
    data() {
      return {
        showLoginBtn: true,
      }
    },
    computed: {
      ...mapState(['gameName', 'region']),
    },
    methods: {
      login(type) {
        this.$refs.loginComp && this.$refs.loginComp.loginBtn(type)
      },
      getLoginResult(res) {
        this.showLoginBtn = false
        this.$emit('login', res)
      },
    },
  }
</script>

<style scoped lang="scss" src="./HorizontalScreen.scss"></style>
